module.exports = __webpack_public_path__ + "img/user.f3934439.png";